export function formatSearchTerm(term?: string): string {
  if (!term)
    return ''
  return term.includes(';') ? term : `*${term}*`
}

export function buildQueryParams(params: Record<string, unknown>): Record<string, unknown> {
  const definedParams: Record<string, unknown> = {}
  for (const key in params) {
    if (params[key] === false || !!params[key]) {
      definedParams[key] = params[key]
    }
  }
  return definedParams
}
